/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  ReleaseService,
  type Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto,
} from '../../services/wealthlane-award-services';
import { ReleaseFilterService } from '../../services/wealthlane-award-services/services/ReleaseFilterService';

const usePostReleaseCalculateTax = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  isSelectAllActive?: boolean,
  releaseId?: string,
  filter?: any,
  openSubmitModal?: () => void,
  setTaskReferenceNo?: any,
  onSuccessCallback?: () => void,
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const { filter: searchKeyWord, ...restFilter } = filter || {};
      const transformedFilter = {
        ...restFilter,
        searchKeyWord: searchKeyWord
      };
      return await handleRequest(
        isSelectAllActive
          ? ReleaseFilterService.postApiAwardApiAppReleaseFilterCalculateTaxByFilter({
            releaseId: releaseId,
            filter: transformedFilter,
          })
          : ReleaseService.postApiAwardApiAppReleaseCalculateTax(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          if (response.sentToBackground === true) {
            openSubmitModal();
            setTaskReferenceNo(response.taskReferenceNo);
          } else {
            await queryClient.invalidateQueries('getReleaseIncludedList');
            toast.success(<ToastComponent label='Success' message='Tax Calculated' />);
            onSuccessCallback?.();
          }
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostReleaseCalculateTax;
